import { useEffect, useMemo, useState } from "react";
import AddToTradeIconButton from "./AddToTradeIconButton";

export default function AddToTradeQuantityControl({
  cardName,
  maxQty = 1,
  disabled = false,
  disabledReason = "",
  busy = false,
  onAdd,
}) {
  const safeMaxQty = Math.max(1, Number(maxQty) || 1);
  const [selectedQty, setSelectedQty] = useState(1);
  const quantityOptions = useMemo(
    () => Array.from({ length: safeMaxQty }, (_, index) => index + 1),
    [safeMaxQty]
  );

  useEffect(() => {
    setSelectedQty((currentQty) => Math.min(Math.max(1, currentQty), safeMaxQty));
  }, [safeMaxQty]);

  return (
    <div
      onClick={(event) => event.stopPropagation()}
      onMouseDown={(event) => event.stopPropagation()}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: "6px",
        minWidth: 0
      }}
    >
      <select
        aria-label={`Quantity of ${cardName || "card"} to add to trade`}
        title="Select quantity to add"
        disabled={disabled || busy || typeof onAdd !== "function"}
        value={selectedQty}
        onClick={(event) => event.stopPropagation()}
        onChange={(event) => {
          event.stopPropagation();
          setSelectedQty(Math.min(Math.max(1, Number(event.target.value) || 1), safeMaxQty));
        }}
        style={{
          height: "26px",
          minWidth: `${Math.max(42, String(safeMaxQty).length * 11 + 30)}px`,
          padding: "0 6px",
          borderRadius: "8px",
          border: "1px solid #cbd5e1",
          background: disabled ? "#f8fafc" : "#ffffff",
          color: disabled ? "#94a3b8" : "#0f172a",
          fontSize: "12px",
          fontWeight: 600,
          cursor: disabled || busy || typeof onAdd !== "function" ? "not-allowed" : "pointer"
        }}
      >
        {quantityOptions.map((qty) => (
          <option key={qty} value={qty}>
            {qty}
          </option>
        ))}
      </select>
      <AddToTradeIconButton
        cardName={cardName}
        disabled={disabled}
        disabledReason={disabledReason}
        busy={busy}
        onClick={() => {
          if (typeof onAdd === "function") {
            onAdd(selectedQty);
          }
        }}
      />
    </div>
  );
}